import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import ReadOnly from '../../../shared/components/dataEntry/ReadOnly';

interface HistorialOptometricProps {
  create: boolean,
  watch: boolean,
  hookForms: any
}

export default function HistorialOptometric({ create, watch: watchMode, hookForms }:HistorialOptometricProps) {
  const historial = useSelector((state:any) => state.fichaOptometricaWorkspace.graduacionSelected?.historial);

  const {
    register, setValue, watch,
  } = hookForms;

  const formHistorial = watch('historial');
  useEffect(() => {
    if (!create && historial && Object.entries(formHistorial).length === 0) {
      Object.entries(historial).forEach(([key, value]) => {
        setValue(`historial.${key}`, value);
      });
    }
  }, [historial]);

  const arrayOfInputs = [
    {
      title: 'Motivo Visita',
      name: 'historia_motivo_visita',
    },
    {
      title: 'Historia médica / Historia del desarrollo',
      name: 'historia_medica',
    },
    {
      title: 'Historia ocular',
      name: 'historia_ocular',
    },
    {
      title: 'Historia familiar',
      name: 'historia_familiar',
    },
    {
      title: 'Polo anterior',
      name: 'polo_anterior',
    },
    {
      title: 'Polo posterior',
      name: 'polo_posterior',
    },
  ];

  return (
    <>
      {arrayOfInputs.map(row => (
        <div key={row.name} className="bodyInfo flexCol">
          <div className="flexRow spaceBetween">
            <h3>{row.title}</h3>
          </div>
          <ReadOnly condition={watchMode}>
            <input
              disabled={watchMode}
              className="ant-input inputMarginTop"
              type="text"
              placeholder="Escriba aquí..."
              name={`historial.${row.name}`}
              ref={register}
            />
          </ReadOnly>
        </div>
      ))
    }
    </>
  );
}
